import { h } from 'preact';

const Overlay = () => <div className="c-overlay" />;

export default Overlay;
